import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { BaseParams } from 'types/utils'

type BlobAction = 'download' | 'view'

export function useContract() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const onError = useOnError()

  async function downloadContract({
    id,
    params
  }: BaseParams<{
    action?: BlobAction
    type?: 'flat' | 'offer'
  }>) {
    if (!id) throw new Error('Contract ID is required')
    const res = await apiClient.get<Blob>(`${SNA_PREFIX}contracts/${id}`, {
      params: params?.type && { type: params?.type },
      responseType: 'blob'
    })
    return res.data
  }

  return useMutation({
    mutationFn: downloadContract,
    onSuccess: (pdfBlob: Blob, variables) => {
      const file = new Blob([pdfBlob], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)

      if (variables.params?.action === 'download') {
        const a = document.createElement('a')
        a.href = fileURL
        a.download = `flat-contract-${variables.id}.pdf`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        const newTab = window.open(fileURL, '_blank')
        newTab &&
          toast.error({
            message: t('popupBlocked')
          })
      }

      URL.revokeObjectURL(fileURL)
    },
    onError // Updated to use useOnError
  })
}
